import React, { Component, Fragment } from 'react';
import { segmentTrackEvent, sendLog } from '../../utils';

const withSegmentScroll = WrappedComponent => class extends Component {
  constructor() {
    super();
    this.handleScroll = this.handleScroll.bind(this);
  }

  handleScroll() {
    try {
      const pageEndOffset = this.pageEnd.offsetTop - window.outerHeight;

      if (window.scrollY >= pageEndOffset) {
        window.removeEventListener('scroll', this.handleScroll);
        segmentTrackEvent('article_completed', this.props.standardArticleTracker);
      }
    } catch (e) {
      sendLog('withSegmentScroll', 'error', 'Error in handleScroll method of withSegmentScroll');
      throw new Error(`Error in handleScroll method of withSegmentScroll. ${e}`);
    }
  }

  componentDidMount() {
    if (typeof window !== 'undefined') {
      window.addEventListener('scroll', this.handleScroll);
    }
  }

  componentWillUnmount() {
      window.removeEventListener('scroll', this.handleScroll);
  }

  render() {
    const renderedWrappedComponent = React.isValidElement(WrappedComponent) ? WrappedComponent : <WrappedComponent {...this.props} />;
    return (
        <Fragment>
          {renderedWrappedComponent}
          <div className="page-end" ref={el => this.pageEnd = el} />
        </Fragment>
    );
  }
};

export default withSegmentScroll;
